import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../App";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Button } from "./ui/button";
import { FileText, ClipboardList, HardHat, ClipboardSignature } from "lucide-react";
import { MANAGE_ROLES } from "./handover/handoverApi";

export default function DefectsManagement() {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);

  return (
    <div className="p-4 sm:p-8 max-w-7xl mx-auto">
      <div className="mb-8">
        <h1 className="heading-primary text-3xl sm:text-4xl mb-2">
          Defects Management
        </h1>
        <p className="text-lg text-slate-600">
          Manage defects across all your sites
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 max-w-6xl">
        <Card
          className="dashboard-card cursor-pointer transition-all duration-200 hover:scale-105 hover:shadow-xl"
          onClick={() => navigate("/defects/details")}
        >
          <CardContent className="p-4">
            <div className="flex flex-col items-center text-center space-y-2">
              <div className="p-2 rounded-lg bg-gradient-to-br from-blue-500 to-blue-600 shadow-lg">
                <ClipboardList className="w-5 h-5 text-white" />
              </div>
              <div>
                <h3 className="font-bold text-base text-slate-900 mb-0.5">
                  Defects Details Page
                </h3>
                <p className="text-xs text-slate-600">
                  View and manage defects by dwelling
                </p>
              </div>
            </div>
          </CardContent>
        </Card>

        <Card
          className="dashboard-card cursor-pointer transition-all duration-200 hover:scale-105 hover:shadow-xl"
          onClick={() => navigate("/defects/reporting")}
        >
          <CardContent className="p-4">
            <div className="flex flex-col items-center text-center space-y-2">
              <div className="p-2 rounded-lg bg-gradient-to-br from-green-500 to-green-600 shadow-lg">
                <FileText className="w-5 h-5 text-white" />
              </div>
              <div>
                <h3 className="font-bold text-base text-slate-900 mb-0.5">
                  Defects Reporting
                </h3>
                <p className="text-xs text-slate-600">
                  Generate and view defect reports
                </p>
              </div>
            </div>
          </CardContent>
        </Card>

        <Card
          className="dashboard-card cursor-pointer transition-all duration-200 hover:scale-105 hover:shadow-xl"
          onClick={() => navigate("/defects/contractors")}
          data-testid="contractor-defects-card"
        >
          <CardContent className="p-4">
            <div className="flex flex-col items-center text-center space-y-2">
              <div className="p-2 rounded-lg bg-gradient-to-br from-amber-500 to-amber-600 shadow-lg">
                <HardHat className="w-5 h-5 text-white" />
              </div>
              <div>
                <h3 className="font-bold text-base text-slate-900 mb-0.5">
                  Contractor Defects Management
                </h3>
                <p className="text-xs text-slate-600">
                  Contractors update their assigned defects
                </p>
              </div>
            </div>
          </CardContent>
        </Card>

        {MANAGE_ROLES.includes(user?.role) && (
          <Card
            className="dashboard-card cursor-pointer transition-all duration-200 hover:scale-105 hover:shadow-xl"
            onClick={() => navigate("/defects/client-walkthroughs")}
            data-testid="client-walkthroughs-card"
          >
            <CardContent className="p-4">
              <div className="flex flex-col items-center text-center space-y-2">
                <div className="p-2 rounded-lg bg-gradient-to-br from-indigo-500 to-indigo-600 shadow-lg">
                  <ClipboardSignature className="w-5 h-5 text-white" />
                </div>
                <div>
                  <h3 className="font-bold text-base text-slate-900 mb-0.5">
                    Client Walkthroughs
                  </h3>
                  <p className="text-xs text-slate-600">
                    Client Handover — clients, walkthroughs and handover links
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        )}
      </div>
    </div>
  );
}
